export const BASE_URL = '/api'
export const CLIENT = 'customer'
export const USER = 'viewer'
export const MODER = 'sender'
export const ADMIN = 'reporter'
